import { render, staticRenderFns } from "./NflBlog.vue?vue&type=template&id=ec8a3324&scoped=true"
import script from "./NflBlog.vue?vue&type=script&lang=js"
export * from "./NflBlog.vue?vue&type=script&lang=js"
import style0 from "./NflBlog.vue?vue&type=style&index=0&id=ec8a3324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8a3324",
  null
  
)

export default component.exports